
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navigationTree } from "../Sidebar/Service";
import "./AdminDashboard.css";

// Import module-specific icons
import userIcon from "../../assets/user.png";
import approvedIcon from "../../assets/employee.png";
import rolesIcon from "../../assets/checklist.png";
import modulesIcon from "../../assets/module.png";
import permissionsIcon from "../../assets/key.png";
import assignmentsIcon from "../../assets/role.png";
import orgIcon from "../../assets/organization.png";
import countriesIcon from "../../assets/world.png";
import defaultIcon from "../../assets/user.png";

const moduleIcons = {
  Users: userIcon,
  "Approved Users": approvedIcon,
  Roles: rolesIcon,
  Modules: modulesIcon,
  "Module Permissions": permissionsIcon,
  "Role Assignments": assignmentsIcon,
  Organizations: orgIcon,
  Countries: countriesIcon,
};

const moduleDescriptions = {
  Users: "List of all registered users. Review and accept or reject access permissions.",
  "Approved Users": "All users who have been granted access, along with their roles and details.",
  Modules: "Manage all application features. Create, update, or remove modules.",
  Roles: "Define access levels (e.g., read/full) for each module. Create and manage roles.",
  "Module Permissions": "Assign module-level permissions to specific roles for access control.",
  "Role Assignments": "Assign existing roles to users, controlling what features they can access.",
  Countries: "Manage list of supported countries. Add or update country information.",
  Organizations: "Manage organization profiles used during user signup. Add or update organization info.",
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [adminModules, setAdminModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    navigationTree().then((items) => {
      const adminRoute = items.find((route) => route.main_Router === "Admin");
      if (adminRoute?.children) {
        const modulesWithMeta = adminRoute.children.map((mod) => ({
          ...mod,
          count: Math.floor(Math.random() * 100),
          icon: moduleIcons[mod.name] || defaultIcon,
          description: moduleDescriptions[mod.name] || "Module information unavailable.",
        }));
        setAdminModules(modulesWithMeta);
      }
      setLoading(false);
    });
  }, []);

  const cardsToRender = loading
    ? Array.from({ length: 8 }).map((_, i) => ({
        name: "",
        description: "",
        icon: null,
        loading: true,
        id: i,
      }))
    : adminModules.map((mod, i) => ({
        ...mod,
        loading: false,
        id: i,
      }));

  return (
    // <div className="admin-dashboard-container">
    //   <div className="admin-cards-grid">
    //     {cardsToRender.map((mod) => (
    //       <div
    //         key={mod.id}
    //         onClick={() => !mod.loading && navigate(`/${mod.path}`)}
    //         className="admin-card group"
    //         style={{ pointerEvents: mod.loading ? "none" : "auto" }}
    //       >
    //         <div className="admin-icon-wrapper">
    //           {mod.loading ? (
    //             <div className="admin-shimmer admin-shimmer-icon" />
    //           ) : (
    //             <img src={mod.icon} alt={`${mod.name}-icon`} className="admin-icon-img" />
    //           )}
    //         </div>
    //         <div className={`admin-module-name ${mod.loading ? "admin-shimmer-text" : ""}`}>
    //           {mod.loading ? "" : mod.name}
    //         </div>
    //         <div
    //           className={`admin-module-description ${
    //             mod.loading ? "admin-shimmer-text short" : ""
    //           }`}
    //         >
    //           {mod.loading ? "" : mod.description}
    //         </div>
    //       </div>
    //    ))}
    //   </div>
    // </div>
       <div className="admin-dashboard-container">
  <div className="admin-cards-grid">
    {cardsToRender.map((mod) => (
      <div
        key={mod.id}
        onClick={() => !mod.loading && navigate(`/${mod.path}`)}
        className="admin-card"
        style={{ pointerEvents: mod.loading ? "none" : "auto" }}
      >
        {/* LOADING SHIMMER */}
        {mod.loading ? (
          <div className="admin-card-front">
            <div className="admin-shimmer admin-shimmer-icon" />
            <div className="admin-shimmer admin-shimmer-text" />
            <div className="admin-shimmer admin-shimmer-text short" />
          </div>
        ) : (
          <>
            {/* FRONT SIDE: ICON + NAME */}
            <div className="admin-card-front">
              <img
                src={mod.icon}
                alt={`${mod.name}-icon`}
                className="admin-icon-img"
              />
              <div className="admin-module-name">{mod.name}</div>
            </div>

            {/* BACK SIDE: DESCRIPTION */}
            <div className="admin-card-back">
              <div className="admin-module-description">"{mod.description}"</div>
            </div>
          </>
        )}
      </div>
    ))}
  </div>
</div>



  );
};

export default AdminDashboard;
